import { makeAutoObservable } from "mobx";
import { fetchPrefs, savePrefs } from "../serviceCalls";
import ErrorReporter from "../shared/ErrorReporter";
import config from "../config";
import _ from "lodash";

export default class ClientPrefsStore {
  prefs;
  prefsFetched;
  prefsPromise;
  constructor({ appStore }) {
    makeAutoObservable(this);
    this.appStore = appStore;
  }
  async setPref(key, value) {
    if (!this.prefs) await this.prefPromise;
    if (!this.prefs || !key) return;
    if (this.useLocalPrefs(key))
      return this.appStore.authStore.storage.setPref(key, value);
    _.set(this.prefs, `userPreferences.client.${key}`, value);
    this.prefs = { ...this.prefs };
    this.savePrefs();
  }
  async getPref(key) {
    await this.prefsPromise;
    if (this.useLocalPrefs(key))
      return _.get(this.appStore.authStore.storage?.prefs, key);
    return _.get(this.prefs, `userPreferences.client.${key}`);
  }
  fetchPrefs() {
    if (this.prefsFetched || !this.appStore.authStore.authToken) return;
    this.prefsFetched = true;
    const { defaultPrefs } = config;
    this.prefsPromise = fetchPrefs()
      .then((prefs) => {
        _.defaultsDeep(prefs.userPreferences.client, defaultPrefs);
        return prefs;
      })
      .then((prefs) => {
        this.prefs = prefs;
        if (config.multiUserAccount && localStorage.prefs) {
          this.prefs.userPreferences.client = JSON.parse(localStorage.prefs);
        }
        return this.prefs;
      })
      .catch((e) => {
        ErrorReporter({
          message: "userconfiguration failed. Your settings may be lost.",
          error: e,
        }); // reload/continue?
        return this.prefs;
      });
    return this.prefsPromise;
  }
  savePrefs() {
    if (config.multiUserAccount) {
      localStorage.prefs = JSON.stringify(this.prefs.userPreferences.client);
      return Promise.resolve({});
    } else {
      return savePrefs({
        userPreferences: {
          client: this.prefs.userPreferences.client,
        },
      });
    }
  }

  useLocalPrefs(key) {
    return config.localPrefs?.keyPaths?.find((keyPath) =>
      key.match(new RegExp(`^${keyPath}($|[\\W])`)),
    );
  }
}
